module.exports = __webpack_public_path__ + "img/cross_hipped.db95118f.jpg";